import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Label } from 'nallian-shared-ui/lib/components';

const IDENTITY_STATUS_OPTIONS = [
  { value: true, color: 'green', key: 'active' },
  { value: false, color: 'red', key: 'inactive' },
];

const IdentityStatus = ({ value }) => {
  const { t } = useTranslation();
  const statusOption = useMemo(
    () => IDENTITY_STATUS_OPTIONS.find(s => s.value === value),
    [value]
  );

  if (!statusOption) {
    return null;
  }

  return <Label round content={t(statusOption.key)} color={statusOption.color} />;
};

IdentityStatus.propTypes = {
  value: PropTypes.bool.isRequired,
};

export default IdentityStatus;
